export enum NOTIFICATION_TYPES {
  ERROR = "error",
  SUCCESS = "success",
  INFO = "info"
}
